module.exports = __webpack_public_path__ + "img/DataAssert.7c853ce9.svg";